// What the homeowner landing page says when its lookup is refused (Oct 22, 2026). ho_find_deal (street number +
// the phone's last 4) limits failed lookups: 5 in 15 minutes and 15 in a day from one device, and 20 in an hour or
// 60 in a day from everyone together (CRM migration 20261022_ho_find_deal_rate_limit.sql). A refusal comes back as
// HTTP 429 (SQLSTATE PT429) with message "too_many_tries" (this device) or "lookups_paused" (everyone), and the
// minutes to wait in `details`. Links sent by text don't use this lookup, so they keep working.

const PHONE = "(470) 823-8816";

/** The words for a refusal, or null when the error is something else. */
export function lookupRefusalText(
  status: number | null | undefined,
  error: { code?: string | null; message?: string | null; details?: string | null } | null | undefined,
): string | null {
  if (!error) return null;
  if (status !== 429 && error.code !== "PT429") return null;
  if (error.message === "lookups_paused") {
    return `Project lookups are paused right now. A link from one of our texts still works, or call or text us at ${PHONE}.`;
  }
  const minutes = Number.parseInt(error.details ?? "", 10);
  const wait = Number.isFinite(minutes) && minutes > 0 ? waitWords(minutes) : "a few minutes";
  return `Too many tries. Please wait ${wait} and try again, or call us at ${PHONE}.`;
}

function waitWords(minutes: number): string {
  if (minutes < 60) return minutes === 1 ? "a minute" : `${minutes} minutes`;
  const hours = Math.ceil(minutes / 60);
  return hours === 1 ? "an hour" : `${hours} hours`;
}
